var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-tree"},[_c('div',{staticClass:"tree-container"},[_c('ul',{staticClass:"root-list"},_vm._l((_vm.treeData),function(node){return _c('TreeNode',{key:node.id,attrs:{"node":node,"search-keyword":_vm.searchKeyword},on:{"node-selected":_vm.handleNodeSelected}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }